













import { FiltroEnviosAutomaticos } from "@/services/consultores.service";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import FiltrosEnvioAutomaticoForm from "../components/FiltrosEnvioAutomaticoForm.vue";
import EnviosAutomaticos from "../tables/EnviosAutomaticos.vue";

@Component({
  components: {
    FiltrosEnvioAutomaticoForm,
    EnviosAutomaticos,
  },
})
export default class TabEnviosAutomaticos extends Vue {
  @Prop() idConsultor!: number;
  loadingEnvios = false;

  filtros: FiltroEnviosAutomaticos = {
    idConsultor: this.idConsultor
  };
}
